export enum FileRecordStatus {
    Created = 1,
    Qc = 2,
    Editing = 3,
    Rejected = 4,
    WaitingForClientResponse = 5,
    Destroyed = 6,
    QcDone = 7
}

export const mapToFileRecordStatus = (status: number | string): FileRecordStatus => {
    const numberStatus = Number(status);

    if (numberStatus in FileRecordStatus) {
        return numberStatus;
    }

    throw new Error("Incorrect file record status.");
};
